const STALE_CHUNK_RELOAD_KEY = 'vite_chunk_reload_at'
const RELOAD_DEBOUNCE_MS = 10_000 // allow at most one reload per 10 s

/**
 * Reloads the page at most once per RELOAD_DEBOUNCE_MS (tracked in sessionStorage).
 *
 * All stale-chunk handlers (vite:preloadError, unhandledrejection, router.onError)
 * call this same function so only the first one wins; subsequent calls within the
 * debounce window are silently ignored, preventing competing navigations and
 * infinite reload loops.
 *
 * The timestamp-based approach (vs. a boolean flag) means the guard naturally
 * expires, so future deploys that cause new chunk errors can still trigger a
 * reload within the same browser session.
 */
export function reloadOnStaleChunk(): void {
  const lastReload = parseInt(sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY) ?? '0', 10)
  const now = Date.now()

  if (now - lastReload < RELOAD_DEBOUNCE_MS) return

  sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, String(now))
  window.location.reload()
}
